/**
 * 開始のじゃんけん（ランダムで遊ぶ試合。ゲームサーバーのルーム。Issue #809）。
 * 両席に同時に出る（input.seat_queries の source rps）。出した手はそろうまで相手に見えない。あいこはもう一度。
 * 勝った席には開始の問い合わせ（先攻・後攻）が来る（PreStartPanel）。query が無い＝この席はもう出した（相手を待つ）
 */
import { btn } from './RespondTab';

const HAND = { rock: 'グー', scissors: 'チョキ', paper: 'パー' };

/** そろった回の結果の文（あいこ・勝ち）。無ければ null */
export function rpsResultText(rps, players = []) {
  const last = rps?.last;
  if (!last) return null;
  const name = (s) => players[s]?.name ?? `P${s + 1}`;
  const w = last.winner;
  return `${name(0)} ${HAND[last.hands?.['0']] ?? '?'} ／ ${name(1)} ${HAND[last.hands?.['1']] ?? '?'}　${w == null ? 'あいこ' : `${name(w)} の勝ち`}`;
}

export default function RpsPanel({ query = null, rps = null, players = [], busy = false, onPick }) {
  const result = rpsResultText(rps, players);
  return (
    <div data-testid="rps-panel" style={{ padding: 14, display: 'flex', flexDirection: 'column', gap: 10 }}>
      <strong style={{ fontSize: 15 }}>{query?.message ?? 'じゃんけん: 相手が出すのを待っています'}</strong>
      {result ? <div data-testid="rps-result" style={{ fontSize: 13, opacity: 0.85 }}>{result}</div> : null}
      {query ? (
        <div style={{ display: 'flex', gap: 8 }}>
          {query.options.map((o) => (
            <button key={o.index} type="button" data-testid={`rps-${o.hand}`} disabled={busy} style={btn('primary', { grow: true })}
              onClick={() => onPick?.(query, o.index)}>{o.label}</button>
          ))}
        </div>
      ) : null}
    </div>
  );
}
